'use client'

import { ReactNode } from 'react'

export function ProvidersIntl({ children }: { children: ReactNode }) {
  return <>{children}</>
}
